import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import AnnouncementCard from '../../../components/AdminCentral/Announcements/AnnouncmentCard';
import AdminNotificationPanel from '../../../components/AdminCentral/Dashboard/AdminNotificationPanel';
const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  min-height: 100vh;
  background-color: transparent;
`;

const ContentContainer = styled.div`
  background: #F8F8F8;
  padding : 20px;
  display: flex;
  gap: 20px;
  width: 90%;
  border-radius: 5px;
`;

const Title = styled.text`
  font-size: 36px;
  color: ${({ colors }) => colors.titleText};
  font-weight: 600;
  margin-bottom: 20px;
  span {
    display: block;
    color: black;
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
`;

const SubscriptionAdminDashboardPage = ({ colors }) => {
  const user = useSelector(state => state.auth.user);
  const userName = user?.first_name || 'Admin';
  
  return (
    <DashboardContainer>
         <Title colors={colors}> Dashboard</Title>
        <ContentContainer>
        <AnnouncementCard colors={colors} /> 
        <AdminNotificationPanel colors={colors} />
        </ContentContainer>
    </DashboardContainer>
  );
};

export default SubscriptionAdminDashboardPage;
